import { createVuetify } from 'vuetify'

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import { aliases, mdi } from 'vuetify/iconsets/mdi-svg'
import {
  mdiAccount,
  mdiChevronLeft,
  mdiChevronRight,
  mdiFilePdfBox,
  mdiBellOutline,
  mdiPageFirst,
  mdiPageLast,
  mdiCheck,
  mdiMessageTextOutline
} from '@mdi/js'

import { pl } from 'vuetify/locale'
import { customIcons } from './icons'
import { szpLightTheme } from './themes'

import '@mdi/font/css/materialdesignicons.css'

export default createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'szpLightTheme',
    themes: {
      szpLightTheme
    }
  },
  locale: {
    locale: 'pl',
    messages: { pl }
  },
  icons: {
    defaultSet: 'mdi',
    aliases: {
      ...aliases,
      ...customIcons,
      account: mdiAccount,
      filePdfBox: mdiFilePdfBox,
      chevronRight: mdiChevronRight,
      chevronLeft: mdiChevronLeft,
      bellOutline: mdiBellOutline,
      pageFirst: mdiPageFirst,
      pageLast: mdiPageLast,
      check: mdiCheck,
      onlineChat: mdiMessageTextOutline
    },
    sets: {
      mdi
    }
  }
})
